import {
  QUOTE_CALCULATED,
  QUOTES_FETCH_REQUESTED,
  QUOTES_FETCHED,
} from 'utils/constants'

export default (state = {}, action) => {
  switch (action.type) {
    case QUOTE_CALCULATED:
      const { quote } = action.data;
      return { ...state, [quote.uuid]: quote };
    case QUOTES_FETCH_REQUESTED:
      return { ...state, fetching: true };
    case QUOTES_FETCHED:
      return { ...state, fetching: false };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/quotes.js